import { Badge } from '@/components/ui/badge';
import { RequestStatus } from '@/types';

interface StatusBadgeProps {
  status: RequestStatus;
}

const statusVariants: Record<RequestStatus, 'draft' | 'submitted' | 'approved' | 'provisioning' | 'provisioned' | 'failed' | 'completed' | 'rejected'> = {
  Draft: 'draft',
  Submitted: 'submitted',
  Approved: 'approved',
  Provisioning: 'provisioning',
  Provisioned: 'provisioned',
  Failed: 'failed',
  Completed: 'completed',
  Rejected: 'rejected',
};

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <Badge variant={statusVariants[status] || 'default'}>
      {status}
    </Badge>
  );
}
